// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Nebula from '@/components/Nebula'

import 'nucleus-ui/src/theme/theme.css'
import 'chartist/dist/chartist.min.css'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-theme-chalk'
import store from './store'
import User from './plugins/user'
import NebApi from '@/plugins/nebApi'
import { mapState } from 'vuex'
import './filters'
import './assets/scss/element-variables.scss'
import VueCompositionAPI from '@vue/composition-api'
import 'vue-toastification/dist/index.css'
import VTooltip from 'v-tooltip'
import client from '@/api/client'

Vue.use(VueCompositionAPI)
Vue.use(VTooltip)

Vue.use(ElementUI, { locale })
Vue.use(User)
Vue.use(NebApi)
Vue.config.lang = 'en'
Vue.config.productionTip = false
Vue.mixin({  // TODO this mixin might be better in a base.js file in the mixins folder that gets imported in App.vue
  computed: {
    ...mapState({
      brandId: state => state.brand.settings.id
    })
  }
})
Vue.use(Nebula)

const init = async () => {
  const envResp = await client.env()
  window.config = envResp.data
  Sentry.init({
    dsn: window.config.SENTRY_FRONTEND_DSN,
    environment: window.config.SENTRY_ENVIRONMENT.toUpperCase(),
    release: window.config.VERSION,
    integrations: [new VueIntegration({Vue, attachProps: true})]
  })
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
  })
}
init()
